import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth, hasPermission } from "../context/AuthContext";
import { homePathForRole } from "../lib/dashboardRole";
import DashboardPage from "./Dashboard";

/** Role-aware home: department staff land on their department dashboard only. */
export default function HomePage() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-[40vh] grid place-items-center text-sm text-muted-foreground">Loading…</div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  const home = homePathForRole(user.role);
  if (home !== "/") return <Navigate to={home} replace />;

  if (!hasPermission(user, "page.dashboard")) {
    return <Navigate to={home} replace />;
  }

  return <DashboardPage />;
}
